module.exports = __webpack_public_path__ + "img/nathalie_de_loeaper_pratique_shiatsu.b27b4461.jpg";